<template>
  <div style="height: 100%">
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="page"
      show-summary
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :table-attrs="tableAttrs"
    >
      <template #colMemberAccount="{ row }">
        <MemberAccountCell
          :row="row"
          :username="row.username"
          :uid="row.uid"
          :vip-level="row.vip_level"
          default-detail-tab-type="betStats"
        />
      </template>
      <template #colWinAmount="{ row }">
        <span
          :class="{
            'text-positive': (row.win_amount || 0) > 0,
            'text-negative': (row.win_amount || 0) < 0,
          }"
        >
          <span v-if="row.win_amount > 0">+</span>
          <span v-if="row.win_amount < 0">-</span>{{ formatAmount(row.win_amount) }}
        </span>
      </template>
      <template #colBetAmount="{ row }">{{ formatAmount(row.bet_amount) }}</template>
      <template #colCreatedAt="{ row }">{{ formatTimestamp(row.created_at) }}</template>
      <template #colStatus="{ row }">
        <el-tag size="mini" :type="formatStatus(row) === 'Win' ? 'success' : 'danger'">
          {{ formatStatus(row) }}
        </el-tag>
      </template>
      <template #colBetId="{ row }">{{ row.bet_id != null ? String(row.bet_id) : '--' }}</template>
    </SchemaTablePage>
    <BettingRecordDetailDialog
      :visible.sync="detailVisible"
      :member-account="detailMemberAccount"
      :member-uid="detailMemberUid"
    ></BettingRecordDetailDialog>
  </div>
</template>

<script>
import { getBetList } from '@/api/finance/moneyManagement'
import { centsToYuan } from '@/utils/amount'
import { formatTimestamp, toUnixSeconds } from '@/utils/time'
import BettingRecordDetailDialog from './components/BettingRecordDetailDialog.vue'
import MemberAccountCell from '@/components/MemberAccountCell.vue'
import SchemaTablePage from '@/components/SchemaTablePage'
export default {
  name: 'BettingManage',
  components: {
    BettingRecordDetailDialog,
    MemberAccountCell,
    SchemaTablePage,
  },
  data() {
    return {
      detailVisible: false,
      detailMemberAccount: '',
      detailMemberUid: 0,
      stats: { bet_amount_total: 0, win_amount_total: 0 },
      tableAttrs: {
        showSummary: true,
        summaryMethod: (...args) => this.getSummaries(...args),
      },
      defaultQuery: {
        username: '',
        bet_id: '',
        game_title: '',
        game_id: '',
        timeRange: [],
      },
      searchSchema: [
        {
          prop: 'username',
          label: '会员账号',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'bet_id',
          label: '注单号',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'game_title',
          label: '游戏名称',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'game_id',
          label: '游戏编号',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          prop: 'timeRange',
          label: '下注时间',
          component: 'datetime-range',
          componentProps: { clearable: true },
        },
        {
          component: 'actions',
          // span: { xs: 24, sm: 24, md: 12, lg: 12 },
        },
      ],
      tableColumns: [
        { prop: 'username', label: '会员账号', minWidth: 140, resizable: false, slot: 'colMemberAccount' },
        { prop: 'game_title', label: '游戏名称', minWidth: 140, resizable: false },
        { prop: 'game_id', label: '游戏编号', minWidth: 80, resizable: false },
        { prop: 'win_amount', label: '输赢情况', width: 100, resizable: false, slot: 'colWinAmount' },
        { prop: 'bet_amount', label: '下注金额', width: 100, resizable: false, slot: 'colBetAmount' },
        { prop: 'created_at', label: '下注时间', width: 140, resizable: false, slot: 'colCreatedAt' },
        { prop: 'status', label: '状态', width: 80, align: 'center', resizable: false, slot: 'colStatus' },
        {
          prop: 'bet_id',
          label: '注单号',
          minWidth: 150,
          showOverflowTooltip: true,
          resizable: false,
          slot: 'colBetId',
        },
      ],
    }
  },
  methods: {
    formatTimestamp,
    request(params) {
      return getBetList(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
        username: query?.username || '',
        bet_id: query?.bet_id || '',
        game_title: query?.game_title || '',
        game_id: query?.game_id || '',
        start_time: 0,
        end_time: 0,
      }
      if (query?.timeRange && query.timeRange.length === 2) {
        params.start_time = toUnixSeconds(query.timeRange[0]) || 0
        params.end_time = toUnixSeconds(query.timeRange[1]) || 0
      }
      return params
    },
    parseResult(res) {
      this.stats = res?.data?.stats || { bet_amount_total: 0, win_amount_total: 0 }
      return {
        list: res?.data?.list || [],
        total: res?.data?.total || 0,
      }
    },
    formatAmount(v) {
      if (v == null) return '0.00'
      return centsToYuan(v)
    },
    formatStatus(row) {
      const win = row.win_amount || 0
      return win > 0 ? 'Win' : 'Lose'
    },
    openDetail(row) {
      this.detailMemberAccount = row.username || ''
      this.detailMemberUid = row.uid || 0
      this.detailVisible = true
    },
    getSummaries(param) {
      const { columns } = param
      const sums = []
      columns.forEach((col, idx) => {
        if (idx === 0) {
          sums[idx] = '投注分数总计'
          return
        }
        if (col.property === 'win_amount') {
          sums[idx] = (this.stats.win_amount_total >= 0 ? '+' : '') + this.formatAmount(this.stats.win_amount_total)
        } else if (col.property === 'bet_amount') {
          sums[idx] = this.formatAmount(this.stats.bet_amount_total)
        } else {
          sums[idx] = ''
        }
      })
      return sums
    },
  },
}
</script>

<style lang="scss" scoped>
.search-actions-col {
  .search-actions-form-item {
    margin-bottom: 0;
    ::v-deep .el-form-item__label {
      padding-right: 8px;
    }
  }
}
.search-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.text-positive {
  color: #67c23a;
  font-weight: 500;
}
.text-negative {
  color: #f56c6c;
  font-weight: 500;
}
</style>
